import { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

export const useSimpleSearch = () => {
  const [inputValue, setInputValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const debouncedSearch = useMemo(
    () => debounce((term: string) => { setSearchTerm(term); }, 500),
    []
  );

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  const handleSearch = useCallback((value: string) => {
    setInputValue(value);
    if (value.length === 0) {
      debouncedSearch.cancel();
      setSearchTerm('');
    } else {
      debouncedSearch(value);
    }
  }, [debouncedSearch]);

  return {
    inputValue,
    searchTerm,
    handleSearch,
  };
};